import { TransactionCodeModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';
import { TransactionCodeGroup } from './transaction-code-group.entity';

export class TransactionCode extends DomainEntity<TransactionCodeModelDto> {
    public static from(dto: TransactionCodeModelDto): TransactionCode {
        return new TransactionCode(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id() {
        return this.dto.id;
    }

    public get code() {
        return this.dto.code ?? '';
    }

    public get description() {
        return this.dto.description ?? '';
    }

    public set description(value: string) {
        this.dto.description = value;
    }

    public get type() {
        return this.dto.type ?? '';
    }

    public get isExcluded() {
        return this.dto.isExcluded ?? false;
    }

    public set isExcluded(value: boolean) {
        this.dto.isExcluded = value;
    }

    public get isDeleted() {
        return this.dto.isDeleted ?? false;
    }

    public get isDescriptionChanged() {
        return this.dto.isDescriptionChanged ?? false;
    }

    public get isTypeChanged() {
        return this.dto.isTypeChanged ?? false;
    }

    public get changeStatus() {
        return this.dto.changeStatus ?? '';
    }

    public get ofxTransactionTypeId() {
        return this.dto.ofxTransactionTypeId;
    }

    public set ofxTransactionTypeId(value: number | undefined) {
        this.dto.ofxTransactionTypeId = value;
    }

    public get ofxTransactionTypeName() {
        return this.dto.ofxTransactionTypeName ?? '';
    }

    public set ofxTransactionTypeName(value: string) {
        this.dto.ofxTransactionTypeName = value;
    }

    public get groups(): TransactionCodeGroup[] {
        return (this.dto.groups ?? []).map(TransactionCodeGroup.from);
    }

    public set groups(value: TransactionCodeGroup[]) {
        this.dto.groups = value.map(g => g.toDto());
    }
}
